export enum ViewMode {
  View = 'view',
  Create = 'create',
  Edit = 'edit',
  Delete = 'delete',
}
